import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { isHidden, PaperComponent } from '../../../utils/helper';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { AppBar, Grid, IconButton, TextField, Toolbar, Typography } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { getFormattedValues } from '../../../utils/formatData';
import moment from 'moment';
import { IoMdCloseCircleOutline } from 'react-icons/io';

DailogBoxwithControls.propTypes = {
  IsOpen: PropTypes.bool.isRequired,
  Message: PropTypes.string.isRequired,
  OnHandelClick: PropTypes.func.isRequired,
  AgreeText: PropTypes.string,
  DisAgreeText: PropTypes.string,
  Title: PropTypes.string,
  showButtons: PropTypes.bool,
  columns: PropTypes.any,
  data: PropTypes.any,
  selectedEditRowId: PropTypes.any,
  handleTableEditChange: PropTypes.func.isRequired,
  renderDynamicForm: PropTypes.func.isRequired
};

export default function DailogBoxwithControls({
  IsOpen,
  Message,
  OnHandelClick,
  Title,
  columns,
  data,
  selectedEditRowId,
  AgreeText = 'Agree',
  DisAgreeText = 'Disagree',
  handleTableEditChange,
  renderDynamicForm
}) {
  return (
    <div>
      <Dialog
        maxWidth="lg"
        open={IsOpen}
        PaperComponent={PaperComponent}
      >
        <AppBar
          style={{ position: 'relative', backgroundColor: '#064473' }}
        >
          <Toolbar>
            <Typography
              variant="h6"
              className="app-header-white"
              style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
            >
              {Message}
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => {
                OnHandelClick(false);
              }}
              aria-label="close"
            >
              <IoMdCloseCircleOutline />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent>
          <DialogContentText>
            <div className="row">
              <div className="col-xs-12">
                <div className="row form-section">
                  {_.orderBy((columns || []),
                    ['editSortOrder'], ['asc']).map((col, i) => (
                      <>
                        {
                          col.renderComponent === undefined && (col.editConfig === undefined || isHidden(data, col)) &&
                          <div className="col-xs-12 col-lg-4" style={{ marginTop: '10px' }} key={'edit-' + i + col.key}>
                            {getFormattedDataOnPopup(col, true, col.isEditable, i, data, handleTableEditChange)}
                          </div>
                        }
                        {col.dynamicRenderForm !== undefined && data[col.dynamicRenderForm] !== undefined && data[col.dynamicRenderForm].length > 0 && <><br /><br />
                          {renderDynamicForm(data)}
                        </>}

                      </>
                    ))}
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className="row bottom-xs">
            <div
              className={'col-xs-12 col-lg-12 field-control'}
              style={{ marginTop: '10px', marginBottom: '10px' }}
            >
              <Button
                size="small"
                variant="contained"
                onClick={() => {
                  OnHandelClick(true);
                }}
                style={{ marginRight: '10px' }}

              >
                {AgreeText}
              </Button>
              <Button
                size="small"
                variant="contained"
                onClick={() => {
                  OnHandelClick(false);
                }}
              >
                {DisAgreeText}
              </Button>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export function getFormattedDataOnPopup(column, showLabel, isEditable, index, row, handleTableValueChange) {
  let value = (row || {})[column.key];
  if (
    (column.editConfig !== undefined && column.editConfig.multiple) ||
    _.camelCase(column.dataFormat) === _.camelCase('MultiText')
  ) {
    value = value ? (value || '').split('|') : [];
  }

  const isAvoidFormatting = column.editConfig?.isAvoidFormatting ?? false;

  const isInErrorState = column.isInErrorState;
  const errorMessage = column.errorMessage;
  if (!column.disabled) {
    switch ((column?.editConfig?.type || '').trim()) {
      case 'DatePicker':
        return (
          <>
            <MuiPickersUtilsProvider
              utils={DateFnsUtils}
              key={'datePicker_filter' + column.key + index}
            >
              <Grid container>
                <KeyboardDatePicker
                  label={<><span>{column.name}</span> {column.isRequired ? <span className="error-text"> *</span> : ''} </>}
                  disabled={false}
                  error={isInErrorState}
                  clearable={true}
                  helperText={errorMessage}
                  id="date-picker-dialog"
                  minDate={column.minDate}
                  maxDate={column.maxDate}
                  className="editable"
                  size="small"
                  margin="normal"
                  format="MM/dd/yyyy"
                  key={'datePickerFilter' + column.key + index}
                  // shouldDisableDate={(date) => { disableDatesForPayCycleStart(date, column.isPayCycle); }}
                  // inputValue={value  || null}
                  fullWidth
                  shouldDisableDate={column.editConfig.shouldDisableDate}
                  value={moment(value).format('MM/DD/YYYY') !== 'Invalid date' &&
                    moment(value).format('MM/DD/YYYY') !== '01/01/0001'
                    ? value
                    : null}
                  onChange={(date) => {
                    // if (
                    //   date !== '' &&
                    //   moment(date).format('MM/DD/YYYY') !== 'Invalid date'
                    // ) {if(dat)
                    handleTableValueChange(
                      getFormattedValues(date, column.dataFormat, true),
                      column.key,
                      row,
                      index
                    );
                    // }
                  }}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                  InputProps={{
                    endAdornment: value && (
                      <IconButton
                        disabled={false}
                        size="small"
                        onClick={() => {
                          handleTableValueChange(
                            null,
                            column.key,
                            row,
                            index
                          );
                        }}
                      >
                        <ClearIcon size="small" />
                      </IconButton>
                    )
                  }}
                  InputAdornmentProps={{
                    position: 'start'
                  }}
                />
              </Grid>
            </MuiPickersUtilsProvider>
          </>
        );
    }
  } else {
    value = (column.dataFormat === 'Date'
      ? (moment(value).format('MM/DD/YYYY') !== 'Invalid date' &&
        moment(value).format('MM/DD/YYYY') !== '01/01/0001'
        ? moment(value).format('MM/DD/YYYY')
        : null)
      : value);
    console.log(value);
    value = isAvoidFormatting
      // ? (isNaN(value) ? 0 : ((value?.toString() || '').slice(-1) === '.' ? value : (Math.round(Math.abs((value)) * 100) / 100)))
      ? (isNaN(value) ? 0 : ((value?.toString() || '').indexOf('.') >= 0 ? value : (Math.round(Math.abs((value)) * 100) / 100)))
      : column.dataFormat === 'Date' ? value : getFormattedValues(value, column.dataFormat, true);

    return (<TextField
      disabled={true}
      margin="normal"
      size="small"
      color="primary"
      className={'special-field'}
      value={value}
      label={<><span>{column.name}</span> </>}
      id={
        `text-field-${'_' + column.key
        }`
      }
      key={
        `text-field-${'_' + column.key
        }`
      }
      InputLabelProps={{ shrink: true }}
      fullWidth
    />);
  }
}
